module.exports = __webpack_public_path__ + "img/florian_h.bb3d7d27.jpg";